import { Tokens, errorMessage } from '../constant';
import { environment } from './environment'

export default {
    setupInterceptors: (axios, isTokens = false, isFormData = false) => {
        axios.interceptors.request.use((config) => {
            if (isTokens) {
                return config;
            }
            let isToken = localStorage.getItem(Tokens.ADMIN_TOKEN);
            if (isToken) {
                config.headers['Authorization'] = `Bearer ${(isToken)}`;
                // config.headers['ngrok-skip-browser-warning'] = true;
            }
            if (!isToken) {
                if (!window.location.href.includes('login')
                    && !window.location.href.includes('register')
                    && !window.location.href.includes('reset-password')
                    && !window.location.href.includes('verify-email')) {
                    window.location.href = "/";
                }
                return config;
            }
            if (isFormData) {
                config.headers['Content-Type'] = 'multipart/form-data';
            }
            config.headers['ngrok-skip-browser-warning'] = true;
            return config;
        },
            (error) => {
                return Promise.reject(error);
            }
        );
        axios.interceptors.response.use(
            response => successHandler(response),
            error => errorHandler(error)
        );
        const errorHandler = (error) => {
            console.log(error)
            const errors = error?.response?.data?.message?.toLowerCase();
            const status = error?.response?.status;
            if (
                (status === 401 && errors === errorMessage.NOT_AUTHENTICATED.toLowerCase()) ||
                errors === errorMessage.TOKEN_NOT_PROVIDED.toLowerCase() ||
                errors === errorMessage.TOKEN_INVALID.toLowerCase() ||
                errors === errorMessage.TOKEN_INVALID_SIGNATURE.toLowerCase() ||
                errors === errorMessage.TOKEN_EXPIRED.toLowerCase()
            ) {
                localStorage.removeItem(Tokens.ADMIN_TOKEN);
                window.location.href = environment.BASE_URL + '/signin';
                return Promise.reject(error);
            } else if (error.response.status === 404) {
                return Promise.reject(error);
            } else if (error.response.status === 500) {
                return Promise.reject(error);
            } else {
                return Promise.reject(error);
            }
        };
        const successHandler = (response) => {
            return response;
        };
    }
};
